import { render, staticRenderFns } from "./TopBar.component.vue?vue&type=template&id=84765ee2&scoped=true"
import script from "./TopBar.component.vue?vue&type=script&lang=js"
export * from "./TopBar.component.vue?vue&type=script&lang=js"
import style0 from "./TopBar.component.vue?vue&type=style&index=0&id=84765ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84765ee2",
  null
  
)

export default component.exports